export default __webpack_public_path__ + "static/media/btg.28d29425.svg";